import React, { useEffect } from 'react';
import Header from '../../components/ui/Header';
import HeroSection from './components/HeroSection';
import WhyWeHoldEventSection from './components/WhyWeHoldEventSection';
import EventProgramSection from './components/EventProgramSection';
import PartnersSection from './components/PartnersSection';
import CommunityGallery from './components/CommunityGallery';
import EngagementFormsSection from './components/EngagementFormsSection';
import GuestsSection from './components/GuestsSection';
import TimelineSection from './components/TimelineSection';
import ClosingCTASection from './components/ClosingCTASection';
import LanguageSelector from './components/LanguageSelector';
import FooterSection from './components/FooterSection';

const LandingPage = () => {
  const updatePageMetadata = (language) => {
    const titles = {
      ar: 'عامٌ على النصر - ٨ ديسمبر ٢٠٢٤، إسطنبول',
      en: 'A Year of Victory - December 8, 2024, Istanbul',
      tr: 'Zaferin Bir Yılı - 8 Aralık 2024, İstanbul'
    };
    document.title = titles?.[language] || titles?.en;

    // Set meta description
    const descriptions = {
      ar: 'في الذكرى الأولى ليومٍ غيّر الوعي السوري، نجتمع لنستعيد اللحظة التي أعادت للوطن صوته، وللناس انتماءهم. سجِّل الآن للمشاركة في الفعالية.',
      en: 'On the first anniversary of a day that changed Syrian consciousness, we gather to reclaim the moment that restored the homeland\'s voice and people\'s sense of belonging. Register now to participate in the event.',
      tr: 'Suriye bilincini değiştiren bir günün ilk yıldönümünde, vatanın sesini ve halkın aidiyet duygusunu geri getiren anı yeniden kazanmak için bir araya geliyoruz. Etkinliğe katılmak için şimdi kayıt olun.'
    };
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription?.setAttribute('content', descriptions?.[language] || descriptions?.en);
    }
  };

  useEffect(() => {
    // Set page title based on language
    const savedLanguage = localStorage.getItem('memorial-language') || 'en';
    updatePageMetadata(savedLanguage);

    // Apply initial language settings
    const language = savedLanguage === 'ar' ? 'ar' : 'en';
    document.documentElement.dir = savedLanguage === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = language;

    // Listen for language changes
    const handleLanguageChange = (event) => {
      const newLanguage = event.detail?.language || 'en';
      updatePageMetadata(newLanguage);
    };

    window.addEventListener('languageChanged', handleLanguageChange);
    return () => window.removeEventListener('languageChanged', handleLanguageChange);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <Header />

      {/* Fixed Language Selector */}
      <div className="fixed top-4 right-4 z-language-selector">
        <LanguageSelector />
      </div>

      {/* Hero Section */}
      <HeroSection />

      {/* Why We Hold Event Section */}
      <WhyWeHoldEventSection />

      {/* Event Program Section */}
      <EventProgramSection />

      {/* Partners Section */}
      <PartnersSection />

      {/* Community Gallery */}
      <CommunityGallery />

      {/* Engagement Forms Section */}
      <EngagementFormsSection />

      {/* Guests Section */}
      {/* <GuestsSection /> */}

      {/* Timeline Section */}
      <TimelineSection />

      {/* Closing CTA Section */}
      <ClosingCTASection />

      {/* Footer Section */}
      <FooterSection />
    </div>
  );
};

export default LandingPage;